import { useEffect, useRef, useState } from 'react';
import api from '../api';
import { useGeolocation } from './useGeolocation';

const PUSH_INTERVAL_MS = 10000;

// Pushes the driver's GPS fix to the backend every 10s while `enabled`.
export function useDriverLocationSharing(enabled) {
  const { coords, status } = useGeolocation(enabled);
  const coordsRef = useRef(null);
  const [lastPushedAt, setLastPushedAt] = useState(null);
  coordsRef.current = coords;
  const hasCoords = !!coords;

  useEffect(() => {
    if (!enabled || !hasCoords) return undefined;
    let cancelled = false;
    const push = async () => {
      const c = coordsRef.current;
      if (!c) return;
      try {
        await api.post('/api/driver/location', { lat: c.lat, lng: c.lng });
        if (!cancelled) setLastPushedAt(Date.now());
      } catch { /* ignore */ }
    };
    push();
    const id = setInterval(push, PUSH_INTERVAL_MS);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, [enabled, hasCoords]);

  return { status, coords, lastPushedAt };
}
